import type { ReactEventHandler, ReactNode } from "react";

export enum ToastType {
  Success = "Success",
  Warning = "Warning",
  Error = "Error",
  Information = "Information",
}

/** 모달 하단 버튼 */
export interface IModalButton {
  label: string;
  onClick?: (e?: ReactEventHandler<HTMLButtonElement>) => void;
}

/**
 * 공용 모달.
 * 아래 플래그들은 쓰는 앱만 있고 나머지는 넘기지 않는다 (전부 optional).
 */
export interface IModal {
  title: string;
  content: ReactNode | string;
  onClickClose?: (e?: ReactEventHandler<HTMLButtonElement>) => void;
  confirm?: IModalButton;
  cancel?: IModalButton;
  /** 취소 버튼 자체를 숨긴다 */
  isHideCancelButton?: boolean;
  /** 확인 버튼 자체를 숨긴다 (sunlove) */
  isHideConfirmButton?: boolean;
  /** 넓은 모달 (khakis) */
  isWide?: boolean;
}

/** 공지/안내용 서브 모달 */
export interface ISubModal {
  title: string;
  content: ReactNode | string;
  id?: string;
  handle?: string;
  /** 액션 문구 (wellbeingexpress) */
  actionText?: string;
}

/** 문서 메타 태그 */
export interface IMeta {
  title: string;
  description?: string;
  /** OG 이미지 (tune) */
  imageSrc?: string;
}

/**
 * 토스트.
 * 앱마다 쓰는 필드가 달라 전부 optional로 둔다
 * (기존에는 앱별로 `type`/`message`가 required였으나, 공통화하며 완화).
 */
export interface IToast {
  message?: string;
  type?: keyof typeof ToastType;
  /** 다중 토스트 식별자 */
  id?: string;
  /** 제목 (yeseyesee) */
  title?: string;
}

/**
 * 레이아웃 스토어 공통 베이스.
 * 앱마다 패널 구성이 달라, 5개 앱에서 타입까지 동일한 멤버만 모았다.
 * 각 앱은 이걸 extends 해서 자기 패널·토스트 형태를 덧붙인다.
 */
export interface ILayoutStoreBase {
  isOpenCart: boolean;
  isOpenSearch: boolean;
  isShowDim: boolean;
  isShowFooter: boolean;
  modal: IModal | null;

  openToast: (toast: IToast) => void;
  closeSubModal: () => void;
  showDim: (isShowDim: boolean) => void;
  showFooter: (isShowFooter: boolean) => void;
}
